var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget',{attrs:{"max-height":_vm.maxHeight,"title":"Your Review Items"}},[_c('div',{staticClass:"text-center"},[_c('h2',[_vm._v("Hey there - Look up!")]),_c('p',[_vm._v("We have all your review items in a dedicated panel at the top now!")]),_c('i',{staticClass:"fa fa-arrow-circle-up fa-5x text-success"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }